function Pressreleases() {
	return <div>Press Releases</div>
}

export default Pressreleases